import React from "react";
import { useNavigate } from "react-router-dom";

function Breadcrumb({ breadcrumb, currentPage }) {
  const navigate = useNavigate();

  return (
    <div className="text-gray-400 text-sm my-3 flex flex-wrap">
      {breadcrumb.map((item, index) => (
        <React.Fragment key={index}>
          <span
            className={`cursor-pointer ${
              currentPage === item.label ? "font-bold" : ""
            }`}
            onClick={() => navigate(item.path)}
          >
            {item.label}
          </span>
          <span className="ml-1 mr-1">{`>`}</span>
        </React.Fragment>
      ))}
      <span className="text-black">{currentPage}</span>
    </div>
  );
}

export default Breadcrumb;
